import "../css/Plan.css"
import { Helmet } from 'react-helmet';


export const Plan = () => {
  return (

    <div style={{ "padding": "5%" }} className="Plan">
      <Helmet>
        <title>釣り物・料金プラン｜有明海・大牟田市三池港発釣り船 【シーラインⅢ】</title>
        <meta name="description" content="釣り船シーラインⅢの料金プランと釣り物一覧。イルカウォッチング・チャーター便の詳細も掲載しています。" />
        <meta name="keywords" content="有明海 釣り船, シーラインⅢ 料金, 釣り船 料金" />
        <meta property="og:url" content="https://sealine3-new.web.app/Plan" />
        <link rel="canonical" href="https://sealine3-new.web.app/Plan" />
      </Helmet>
      <h1>釣り物・料金</h1>
      <p>※全てお一人様の料金です。</p>
      <p>乗り合わせでの出航になります。（都合が合えば１名様から出航いたします。）<br />
        釣り仲間、ご家族でのチャーター便もございますので、お気軽にご相談ください。</p>
      <h3>季節</h3>
      <span>
        <tbody className='fishing_table' >
          <tr>
            <td className="col_title">時期</td>
            <td className="row_title">釣り物</td>
          </tr>
          <tr>
            <td className="col_title">1月</td>
            <td style={{ 'paddingLeft': '10px' }}>真鯛・メバル・青物・根魚</td>
          </tr>
          <tr>
            <td className="col_title">2月</td>
            <td style={{ 'paddingLeft': '10px' }}>メバル・青物・根魚</td>
          </tr>
          <tr>
            <td className="col_title">3月</td>
            <td style={{ 'paddingLeft': '10px' }}>メバル・青物・根魚</td>
          </tr>
          <tr>
            <td className="col_title">4月</td>
            <td style={{ 'paddingLeft': '10px' }}>真鯛・メバル・ヒラメ・根魚</td>
          </tr>
          <tr>
            <td className="col_title">5月</td>
            <td style={{ 'paddingLeft': '10px' }}>真鯛・ヒラメ・根魚・キス・イサキ</td>
          </tr>
          <tr>
            <td className="col_title">6月</td>
            <td style={{ 'paddingLeft': '10px' }}>真鯛・ヒラメ・根魚・キス・イサキ・アジ</td>
          </tr>
          <tr>
            <td className="col_title">7月</td>
            <td style={{ 'paddingLeft': '10px' }}>真鯛・ヒラメ・根魚・キス・イサキ</td>
          </tr>
          <tr>
            <td className="col_title">8月</td>
            <td style={{ 'paddingLeft': '10px' }}>真鯛・ヒラメ・根魚・キス・イサキ</td>
          </tr>
          <tr>
            <td className="col_title">9月</td>
            <td style={{ 'paddingLeft': '10px' }}>真鯛・ヒラメ・青物・根魚</td>
          </tr>
          <tr>
            <td className="col_title">10月</td>
            <td style={{ 'paddingLeft': '10px' }}>	真鯛・青物・根魚</td>
          </tr>
          <tr>
            <td className="col_title">11月</td>
            <td style={{ 'paddingLeft': '10px' }}>真鯛・ヒラメ・青物・根魚</td>
          </tr>
          <tr>
            <td className="col_title">12月</td>
            <td style={{ 'paddingLeft': '10px' }}>真鯛・ヒラメ・青物・根魚</td>
          </tr>
        </tbody>
      </span>
      <br />
      <h3 className="obi5">料金</h3>
      <div>
        <tbody className='charge_table' >
          <tr>
            <td className="col_title"></td>
            <td className="row_title1">料金</td>
            <td className="row_title2">狙い魚</td>
          </tr>
          <tr>
            <td className='col_title'>有明海近海</td>
            <td style={{ 'paddingLeft': '10px' }}>7000円</td>
            <td style={{ 'paddingLeft': '10px' }}>キス・ヒラメ</td>
          </tr>
          <tr>
            <td className='col_title'>天草湯島</td>
            <td style={{ 'paddingLeft': '10px' }}>12000円</td>
            <td style={{ 'paddingLeft': '10px' }}>真鯛・根魚</td>
          </tr>
          <tr>
            <td className='col_title'>天草島原</td>
            <td style={{ 'paddingLeft': '10px' }}>10000円</td>
            <td style={{ 'paddingLeft': '10px' }}>真鯛・メバル</td>
          </tr>
          <tr>
            <td className='col_title'>天草鬼池</td>
            <td style={{ 'paddingLeft': '10px' }}>12000円</td>
            <td style={{ 'paddingLeft': '10px' }}>イサキ</td>
          </tr>
          <tr>
            <td className='col_title'>天草富岡</td>
            <td style={{ 'paddingLeft': '10px' }}>13000円</td>
            <td style={{ 'paddingLeft': '10px' }}>真鯛・根魚・イサキ</td>
          </tr>
          <tr>
            <td className='col_title'>牛深沖</td>
            <td style={{ 'paddingLeft': '10px' }}>13000～15000円</td>
            <td style={{ 'paddingLeft': '10px' }}>真鯛・青物</td>
          </tr>
        </tbody>
        <p>※トカラ列島・アジ曽根・こしき島・ジギング要望があれば出港します！</p>

        <tbody className='charge_table' >
          <tr>
            <td className='col_title'>イルカウォッチング</td>
            <td style={{ 'width': '350px', 'paddingLeft': '10px' }}>ご相談ください</td>
          </tr>
          <br />
          <tr>
            <td className='col_title'>チャーター便</td>
            <td style={{ 'paddingLeft': '10px' }}>[平日]6名様より<br />[土日祝日]7名様より<br />各釣り物対応</td>
          </tr>
        </tbody>
        <p style={{ 'fontSize': '18px', 'marginBottom': '0' }}>☆チャータ－便について☆</p>
        <p>
          通常は乗り合わせての出港になりますが、釣り好きの仲間・ご家族などグループで<br />
          船を貸し切っての出港となります。<br />
          そこで良いところが！<br />
          ☆例えば、一人10,000円の場合…<br />
          6名様でのご利用で『60,000円』になります。<br />
          しかし、6名以上でチャーター便をご利用して頂くと、お得なんです!<br />
          7名様でご利用頂いても『60,000円』 一人あたり『8500円』<br />
          10名様のご利用でも『60,000円』一人あたり『6000円』で行けちゃうんです！<br />
          ※料金は行き先によって異なりますので、詳しくは電話でお問い合わせください。</p>
      </div>
    </div>
  );
};


